import { render, staticRenderFns } from "./EditCourseAddress.vue?vue&type=template&id=49ccd912&"
import script from "./EditCourseAddress.vue?vue&type=script&lang=js&"
export * from "./EditCourseAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports